import { IThoiKhoaBieu } from "../model/respone/classes/IThoiKhoaBieu";

/**
 * Mirror logic backend `Service/CongDangKy/Helpers/ScheduleConflictChecker.cs` (rule 9 — case CHUẨN).
 *
 * Dùng cho optimistic update sau register/cancel: classesReducer cần biết các lớp khác
 * có trùng lịch với lớp vừa đăng ký không, để flag canRegister=false ngay (không phải đợi
 * SV click rồi backend mới báo).
 *
 * Không cover GDTC special case (cần `id_bm`/`hoc_ky`/`nam_hoc` không có ở payload FE) —
 * backend vẫn là source of truth khi POST register, sẽ catch GDTC conflict ở đó.
 */

const parseDdmmyyyy = (s?: string): number | null => {
    if (!s) return null;
    const [d, m, y] = s.split("/").map(Number);
    if (!d || !m || !y) return null;
    return new Date(y, m - 1, d).getTime();
};

const dateRangeOverlap = (a: IThoiKhoaBieu, b: IThoiKhoaBieu): boolean => {
    const aFrom = parseDdmmyyyy(a.tu_ngay);
    const aTo = parseDdmmyyyy(a.den_ngay);
    const bFrom = parseDdmmyyyy(b.tu_ngay);
    const bTo = parseDdmmyyyy(b.den_ngay);
    // Thiếu ngày → coi như overlap (defensive — match backend DateRangeOverlap).
    if (aFrom == null || aTo == null || bFrom == null || bTo == null) return true;
    return aFrom <= bTo && bFrom <= aTo;
};

const tietRangeOverlap = (a: IThoiKhoaBieu, b: IThoiKhoaBieu): boolean => {
    if (a.so_tiet <= 0 || b.so_tiet <= 0) return false;
    const aEnd = a.tiet + a.so_tiet;
    const bEnd = b.tiet + b.so_tiet;
    return a.tiet < bEnd && b.tiet < aEnd;
};

export const hasScheduleConflict = (
    a?: IThoiKhoaBieu[],
    b?: IThoiKhoaBieu[]
): boolean => {
    if (!a || !b || a.length === 0 || b.length === 0) return false;
    for (const sa of a) {
        for (const sb of b) {
            if (sa.thu !== sb.thu) continue;
            if (!dateRangeOverlap(sa, sb)) continue;
            if (!tietRangeOverlap(sa, sb)) continue;
            return true;
        }
    }
    return false;
};
